import React from "react";
import { Container } from "react-bootstrap";
import MainSubHeading from "../Sub-Heading/MainSubHeading";
import projectManger from "../../assets/jobsProfile/Project-Manager-JD.pdf"
import computerVision from "../../assets/jobsProfile/Computer-Vision-Engineer-JD.pdf"
import fullstack from "../../assets/jobsProfile/Fullstack-Developer-JD.pdf"
import halthcareAiInterns from "../../assets/jobsProfile/HAI-Interns-Recruitment-2025.pdf"
export default function Careers() {
  const subheadingData = "WORK WITH US"
  return (
    <div>
      <Container>
        <MainSubHeading subheading={subheadingData} />
        <div className="py-md-3">
          <p>
          IHub-Data is on the lookout for passionate and talented individuals who are ready to shape the future with innovation and creativity. If you are passionate about creating real impact, we invite you to explore our exciting career opportunities.
          </p>
          <p>Discover Your Next Role:</p>
          <p>Click below to view all our current openings.</p>
          <ul>
            <li className="py-2">
              <a href={projectManger} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Project Manager</a>
            </li>
            <li className="py-2">
              <a href={computerVision} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Computer Vision Engineers</a>
            </li>
            <li className="py-2">
              <a href={fullstack} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Fullstack Developers</a>
            </li>
            <li className="py-2">
              <a href={halthcareAiInterns} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Healthcare & AI Interns</a>
            </li>
          </ul>

          <p>Please Note: Clicking the link will open a new tab.</p>
        </div>
      </Container>
    </div>
  );
}
